










import { Vue, Component, Prop } from "vue-property-decorator";
import { IPopUpInfo, PopupInfoType } from "./types";
import Map from "./Map";

@Component
export default class HoverInfo extends Vue {
  @Prop({
    default: null
  }) title: string;
  @Prop({
    default: null
  }) items: string[];

  $this = null;
  
  mounted() {
    this.$this = this;
    this.onMounted();
  }

  onMounted() {
    // to be overridden by application
  }

}
